<template>
  <div>
    <!--        :title="`选品库(${item?.title ?? '请选择选品库'})`"-->
    <el-dialog
        :title="`选品库(${Object.keys(item).length !== 0?item.title:'请选择选品库'})`"
        :visible.sync="dialog"
        top="50px"
        width="98%"
        @close="closeChange"
        :append-to-body='true'
        :close-on-click-modal='false'
        :close-on-press-escape='false'
    >
      <el-row
          v-if="index==0"
          v-loading="loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          element-loading-spinner="el-icon-loading"
          element-loading-text="请求推送中..请勿刷新网页">
        <el-col :span="4">
          <div style="padding: 10px">
            <el-form id="topicGoodsForm" :model="selectionGoods" label-position="top" label-width="80px">
              选品库ID: {{ selectionGoods.topicId ? selectionGoods.topicId : "请自行选择选品库" }}
<!--              {{ chooseTopicId }} {{ item }}-->
              <el-form-item label="请选择选品库">
                <el-select filterable v-model="chooseTopicId" placeholder="请选择" style="width: 100%"
                           @change="updateTopicItem()">
                  <el-option label="请选择" value="">
                  </el-option>
                  <el-option
                      v-for="item in topicListVo"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="请选择商品库">
                <el-row>
                  <el-col :span="12">
                    <el-button type="danger" @click="queryGetList(null, 1)">京东商品库</el-button>
                  </el-col>
                  <el-col :span="12">
                    <el-button type="primary" @click="queryGetList(null, 2)">厂供商品库</el-button>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="商品名称">
                <el-input v-model="selectionGoods.title" placeholder="请输入需要查询的商品名称"></el-input>
              </el-form-item>
              <el-form-item label="一级类别">
                <el-select filterable v-model="selectionGoods.categoryId1Name" placeholder="请选择" style="width: 100%"
                           @change="getCategory1List(1)">
                  <el-option label="请选择" value="">
                  </el-option>
                  <el-option
                      v-for="(item,index) in categoryId1"
                      :key="index"
                      :label="item.fullName"
                      :value="item.categoryId">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="二级类别">
                <el-select filterable v-model="selectionGoods.categoryId2Name" placeholder="请选择" style="width: 100%"
                           @change="getCategory1List(2)">
                  <el-option label="请选择" value="">
                  </el-option>
                  <el-option
                      v-for="(item,index) in categoryId2"
                      :key="index"
                      :label="item.fullName"
                      :value="item.categoryId">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="三级类别">
                <el-select filterable v-model="selectionGoods.categoryId3Name" placeholder="请选择" style="width: 100%"
                           @change="queryGetList">
                  <el-option label="请选择" value="">
                  </el-option>
                  <el-option
                      v-for="(item,index) in categoryId3"
                      :key="index"
                      :label="item.fullName"
                      :value="item.categoryId">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="评论数最小值" v-if="selectionGoods.isJd == 1">
                <el-input v-model="selectionGoods.commentOkCount" placeholder="评论最小值" style="width: 45%;"></el-input>
              </el-form-item>
              <el-form-item label="配送方式" v-if="selectionGoods.isJd == 1">
                <el-select v-model="selectionGoods.logisticsType" placeholder="请选择配送方式" style="width: 100%">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="京东" :value="1"></el-option>
                  <el-option label="其他" :value="0"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="折扣区间">
                <el-input v-model="selectionGoods.minProfitMargin" placeholder="最小值" style="width: 45%;"></el-input>
                <span style="margin: 0 5px;">~</span>
                <el-input v-model="selectionGoods.maxProfitMargin" placeholder="最大值" style="width: 45%;"></el-input>
              </el-form-item>
              <!--              <el-form-item label="评论数">
                              <el-select v-model="selectionGoods.commentType" placeholder="请选择" style="width: 100%"
                                         @change="queryGetList">
                                <el-option label="请选择" value="">
                                </el-option>
                                <el-option
                                    v-for="item in commentType()"
                                    :key="item.count"
                                    :label="item.title"
                                    :value="item.count">
                                </el-option>
                              </el-select>
                            </el-form-item>-->
              <el-form-item label="排序">
                <el-select v-model="selectionGoods.priceSort" placeholder="请选择" style="width: 100%"
                           @change="queryGetList">
                  <el-option label="默认" value=""></el-option>
                  <el-option label="正序" value="asc"></el-option>
                  <el-option label="倒序" value="desc"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品状态" v-if="selectionGoods.isJd == 1">
                <el-select v-model="selectionGoods.status" placeholder="请选择状态" style="width: 100%">
                  <el-option label="请选择" value=""></el-option>
                  <el-option label="上架" :value="1"></el-option>
                  <el-option label="下架" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="全国分销价区间">
                <el-input v-model="selectionGoods.minSupplyPrice" placeholder="最小值" style="width: 45%;"></el-input>
                <span style="margin: 0 5px;">~</span>
                <el-input v-model="selectionGoods.maxSupplyPrice" placeholder="最大值" style="width: 45%;"></el-input>
              </el-form-item>
              <el-form-item style="margin-top: 20px">
                <el-button type="primary" @click="queryGetList" @keyup.enter.native="queryGetList">筛选</el-button>
                <el-button @click="reset">重置</el-button>
              </el-form-item>
              <el-form-item v-if="false" label="商品ID">
                <el-input v-model="selectionGoods.goodsId" placeholder="请输入需要查询的商品ID"></el-input>
              </el-form-item>
              <el-form-item v-if="false" label="商品货源">
                <el-radio-group v-model="selectionGoods.isJd" size="small" @input="isJdChange">
                  <el-radio-button :label="1">京东货源</el-radio-button>
                  <el-radio-button :label="2">自营货源</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
        <el-col :span="20">
          <div style="padding: 10px;">
            <div v-show="moreConditions" style="display: flex;justify-content: flex-start;align-items: center;">
                <div  v-for="(topicTag, index) in tagListVo" :key="topicTag.topicId" class="me-2">
                  <el-popover
                      placement="bottom"
                      width="400"
                      trigger="click"
                      popper-class="custom-popper"
                  >
                    <!-- 子标签列表 -->
                    <div style="display: flex;justify-content: flex-start;align-items: center;">
                      <div v-for="tag in topicTag.cagetoryTagList" :key="tag.id" class="me-3">
                        <el-button type="primary" @click="tagDataPopulateSearch(tag)">
                          {{ [tag.categoryName1, tag.categoryName2, tag.categoryName3].filter(name => name).join(' / ')  }}
                        </el-button>
                      </div>
                    </div>

                    <!-- 触发按钮 -->
                    <el-button style="width: 100%;" slot="reference" type="info">
                      {{ topicTag.name }}
                      <i class="el-icon-arrow-down"/>
                    </el-button>
                  </el-popover>
                </div>

                <div>
                  <el-button @click="addTags(1)">添加标签</el-button>
                </div>

            </div>

            <div style="display: flex;justify-content: space-between;width:100%;align-items: center;">
              <el-button type="primary" plain @click="moreConditions = !moreConditions" size="small" class="me-2">
                <span v-if="moreConditions">隐藏标签信息</span>
                <span v-if="!moreConditions">展开标签信息</span>
                <i v-if="moreConditions" class="el-icon-arrow-up"></i>
                <i v-if="!moreConditions" class="el-icon-arrow-down"></i>
              </el-button>
              <div>
                <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bolder fs-3 mb-1">
                选品库商品列表
              </span>
                  <br/>
                  <span class="text-muted mt-1 fw-bold fs-7">
                    请从全部已上架商品列表中，挑选合适的商品放到店铺中展示
                  </span>
                </h3>
              </div>
              <div>
                <!--                <label style="font-weight: bold; font-size: 16px;">京东溢价比率：</label>
                                <el-input v-model="jdRate" size="small" style="width: 7%; margin-right: 6px;" @blur="editRate"></el-input>-->
                <label style="font-weight: bold; margin-right: 6px; font-size: 16px;">分销价加价比率：</label>
                <el-input v-model="rate" size="small" style="width: 7%; margin-right: 6px;" @blur="editRate"></el-input>
                <label style="font-weight: bold; margin-right: 6px; font-size: 16px;">后台加价比率(/)：</label>
                <el-input v-model="systemRate" size="small" style="width: 6%; margin-right: 6px;"></el-input>
                <el-button :plain="index!==0" size="small" type="primary" @click="switchGoods(0)">待选商品</el-button>
                <!--                {{!item?.id}}-->
                <el-button :disabled="Object.keys(item).length === 0" :plain="index!==1" size="small" type="primary" @click="switchGoods(1)">已选商品</el-button>
                <!--                <el-button size="small" type="success" @click="selTopicCurrentGoodsAll">一键挑选</el-button>-->
                <!--                <el-button size="small" type="success" @click="selTopicPushGoodsAll">一键挑选(新)</el-button>-->
                <el-button :disabled="idArr.length===0" size="small" type="success" @click="addNewProductOfChoice">批量添加商品</el-button>
                <el-button @click="showAddressDialog">设置收货地址</el-button>
              </div>
            </div>
            <el-table
                :data="selectGoods"
                :row-class-name="tableRowClassName"
                style="width: 100%"
                @selection-change="handleSelectionChange"
                @expand-change="loadSimilarProducts"
            >
              <!--                row-key="id"
                lazy
                :load="loadSimilarProducts"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"-->
              <el-table-column
                  type="selection"
                  width="30">
              </el-table-column>
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table
                      :data="childData[props.row.id]?.data"
                      v-loading="childData[props.row.id]?.loading"
                      style="width: 95%; margin-left: 5%"
                      :class="`level-${props.row._level || 0}`"
                  >
                    <el-table-column label="信息" width="200px">
                      <template slot-scope="scope">
                        <div v-if="scope.row.picUrl.indexOf('/Uploads') === 0">
                          <div class="d-flex align-items-center">
                            <div class="symbol symbol-50px me-5">
                              <img :src="`https://www.1c-1g.cn${scope.row.picUrl}`" alt="">
                            </div>
                            <div class="d-flex justify-content-start flex-column">
                              <el-tooltip :content="scope.row.title" placement="top">
                                <a :href="scope.row.jdUrl"
                                   class="text-dark fw-bolder text-hover-primary mb-1 fs-6 full-title"
                                   target="_blank" @click="openSearchTab(scope.row)"
                                >{{ scope.row.title }}</a>
                              </el-tooltip>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div class="d-flex align-items-center">
                            <div class="symbol symbol-50px me-5">
                              <img :src="scope.row.picUrl" alt="">
                            </div>
                            <div class="d-flex justify-content-start flex-column">
                              <el-tooltip :content="scope.row.title" placement="top">
                                <a :href="`https://item.jd.com/${scope.row.jdUrl}.html`"
                                   class="text-dark fw-bolder text-hover-primary mb-1 fs-6 full-title"
                                   target="_blank" @click="openSearchTab(scope.row)"
                                >{{ scope.row.title }}</a>
                              </el-tooltip>
                            </div>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="分类" width="120px">
                      <template slot-scope="scope">
                  <span class="text-muted fw-bold text-muted d-block fs-7">
                    {{ scope.row.categoryId1Name ? scope.row.categoryId1Name : "" }}
                    <br>
                    {{ scope.row.categoryId2Name ? scope.row.categoryId2Name : "" }}
                    <br>
                    {{ scope.row.categoryId3Name ? scope.row.categoryId3Name : "" }}
                  </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                        label="来源" width="60">
                      <template slot-scope="scope">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            :content="String(scope.row.skuId)"
                            placement="top">
                          <span>{{ scope.row.isJd == 1 ? "京东" : "自营" }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column label="市场价" width="90">
                      <template slot-scope="scope">
                        <div class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                          {{ scope.row.price | format }}
                        </div>
                        加价：
                        <div class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                          {{ scope.row.price * jdRate | format }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="分销价" width="90">
                      <template slot-scope="scope">
                        <div class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6"
                             @click="editDisPrice(scope.row)">
                          {{ scope.row.supplPrice | format }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="销售价" width="90">
                      <template slot-scope="scope">
                        <div class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                          {{ scope.row.supplPrice * rate | format }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        label="折扣"
                        prop="price" width="90">
                      <template slot-scope="scope">
                        <div v-if="scope.row.isJd==1">
                          <a v-if="scope.row.supplPrice"
                             class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">{{
                              (scope.row.discount
                                  * 10).toFixed(1)
                            }}折</a>
                          <a v-else>-</a>
                        </div>
                        <div v-else>
                          <a v-if="scope.row.supplPrice"
                             class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">{{
                              (((scope.row.poolDisPrice)
                                  / scope.row.price) * 10).toFixed(1)
                            }}折</a>
                          <a v-else>-</a>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        label="销售方式"
                        prop="price" width="100">
                      <template slot-scope="scope">
                  <span v-if="scope.row.lowestBuy == 1 && scope.row.isJd == 1"
                        class="text-muted fw-bold text-muted d-block fs-7">一件代发</span>
                        <span v-else class="text-muted fw-bold text-muted d-block fs-7">
                    集采({{ scope.row.lowestBuy }}个起售)
                  </span>
                      </template>
                    </el-table-column>
                    <el-table-column label="评论" width="100">
                      <template slot-scope="scope">
                  <span class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                    {{ scope.row.commentOkCount }}
                  </span>
                      </template>
                    </el-table-column>
                    <el-table-column label="配送">
                      <template slot-scope="scope">
                  <span v-if="scope.row.logisticsType === 1" class="text-dark fw-bolder text-hover-primary d-block">
                    京东配送
                  </span>
                        <span v-else class="text-dark fw-bolder text-hover-primary d-block">
                    其他配送
                  </span>
                        <div v-if="scope.row.isDelivery" v-for="(status, addressKey) in scope.row.isDelivery" :key="addressKey">
                    <span v-if="status.canPurchase" class="fs-7">
                      {{ addressKey }} 可配送
                    </span>
                          <span v-else class="text-danger fs-7">
                      {{ addressKey }} 不可配送
                    </span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="状态" width="100">
                      <template slot-scope="scope">
                      <span v-if="scope.row.status === 2" class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                        下架
                      </span>
                        <span v-else class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                        上架
                      </span>
                      </template>
                    </el-table-column>
                  </el-table>
                  <!-- 加载状态提示 -->
                  <div v-if="childData[props.row.id]?.loading" class="loading-tip">
                    <i class="el-icon-loading"/> 正在加载子商品...
                  </div>
                </template>

              </el-table-column>
              <el-table-column label="ID" width="88px">
                <template slot-scope="scope">
                  {{ scope.row.id }}
                </template>
              </el-table-column>
              <el-table-column label="信息">
                <template slot-scope="scope">
                  <div v-if="scope.row.picUrl.indexOf('/Uploads') === 0">
                    <div class="d-flex align-items-center">
                      <div class="symbol symbol-50px me-5">
                        <img :src="`https://www.1c-1g.cn${scope.row.picUrl}`" alt="">
                      </div>
                      <div class="d-flex justify-content-start flex-column">
                        <el-tooltip :content="scope.row.title" placement="top">
                          <a href="#"
                             class="text-dark fw-bolder text-hover-primary mb-1 fs-6 full-title"
                             target="_blank" @click="openSearchTab(scope.row)"
                          >{{ scope.row.title }}</a>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="d-flex align-items-center">
                      <div class="symbol symbol-50px me-5">
                        <img :src="scope.row.picUrl" alt="">
                      </div>
                      <div class="d-flex justify-content-start flex-column">
                        <el-tooltip :content="scope.row.title" placement="top">
                          <a :href="`https://item.jd.com/${scope.row.jdUrl}.html`"
                             class="text-dark fw-bolder text-hover-primary mb-1 fs-6 full-title"
                             target="_blank" @click="openSearchTab(scope.row)"
                          >{{ scope.row.title }}</a>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="分类" width="120px">
                <template slot-scope="scope">
                  <span class="text-muted fw-bold text-muted d-block fs-7">
                    {{ scope.row.categoryId1Name ? scope.row.categoryId1Name : "" }}
                    <br>
                    {{ scope.row.categoryId2Name ? scope.row.categoryId2Name : "" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  label="来源" width="60">
                <template slot-scope="scope">
                  <el-tooltip
                      class="item"
                      effect="dark"
                      :content="String(scope.row.skuId)"
                      placement="top">
                    <span>{{ scope.row.isJd == 1 ? "京东" : "自营" }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column label="市场价" width="90">
                <template slot-scope="scope">
                  <div class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                    {{ scope.row.price | format }}
                  </div>
                  加价：
                  <div class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                    {{ scope.row.price * jdRate | format }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="分销价" width="90">
                <template slot-scope="scope">
                  <div class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6"
                       @click="editDisPrice(scope.row)">
                    {{ scope.row.supplPrice | format }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="销售价" width="90">
                <template slot-scope="scope">
                  <div class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                    {{ scope.row.supplPrice * rate | format }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  label="折扣"
                  prop="price" width="90">
                <template slot-scope="scope">
                  <div v-if="scope.row.isJd==1">
                    <a v-if="scope.row.supplPrice"
                       class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">{{
                        (scope.row.discount
                            * 10).toFixed(1)
                      }}折</a>
                    <a v-else>-</a>
                  </div>
                  <div v-else>
                    <a v-if="scope.row.supplPrice"
                       class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">{{
                        (((scope.row.poolDisPrice)
                            / scope.row.price) * 10).toFixed(1)
                      }}折</a>
                    <a v-else>-</a>
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                   label="利润率"
                   prop="price" width="100">
                 <template slot-scope="scope">
                   <div class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                     {{ (scope.row.profit * 100).toFixed(2) }}%
                   </div>
                 </template>
               </el-table-column>-->
              <el-table-column
                  label="销售方式"
                  prop="price" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.lowestBuy == 1 && scope.row.isJd == 1"
                        class="text-muted fw-bold text-muted d-block fs-7">一件代发</span>
                  <span v-else class="text-muted fw-bold text-muted d-block fs-7">
                    集采({{ scope.row.lowestBuy }}个起售)
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="评论" width="100">
                <template slot-scope="scope">
                  <span class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                    {{ scope.row.commentOkCount }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="配送">
                <template slot-scope="scope">
                  <span v-if="scope.row.logisticsType === 1" class="text-dark fw-bolder text-hover-primary d-block">
                    京东配送
                  </span>
                  <span v-else class="text-dark fw-bolder text-hover-primary d-block">
                    其他配送
                  </span>
                  <div v-if="scope.row.isDelivery" v-for="(status, addressKey) in scope.row.isDelivery" :key="addressKey">
                    <span v-if="status.canPurchase" class="fs-7">
                      {{ addressKey }} 可配送
                    </span>
                    <span v-else class="text-danger fs-7">
                      {{ addressKey }} 不可配送
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="状态" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.status === 2" class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                    下架
                  </span>
                  <span v-else class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">
                    上架
                  </span>
                </template>
              </el-table-column>

              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <div>
                    <el-dropdown trigger="click">
                      <el-button size="mini" type="primary">
                        操作 <i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="setTopicCurrentGoodsId(scope.row,1)" icon="el-icon-circle-plus">挑选到当前选品库</el-dropdown-item>
                        <el-dropdown-item @click.native="kfc(scope.row)" icon="el-icon-circle-plus">VWF</el-dropdown-item>
                        <!--                        <el-dropdown-item icon="el-icon-circle-plus-outline" @click.native="setTopicCurrentGoodsId(scope.row,2)">挑选到多个选品库</el-dropdown-item>-->
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
              :page-size="selectionGoods.size"
              :page-sizes="[10, 30, 50,100,200]"
              :total="total"
              :current-page.sync="selectionGoods.current"
              layout="total, sizes, prev, pager, next, jumper"
              style="margin-top: 10px;text-align: center"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange">
          </el-pagination>
        </el-col>
      </el-row>
      <SelGoods v-if="index===1" :items="item" @SwithGoods="switchGoods"></SelGoods>
    </el-dialog>

    <el-dialog title="加价比例" :visible.sync="markUpVisible" :append-to-body='true'
               :close-on-click-modal='false'
               :close-on-press-escape='false'>
      <el-divider content-position="left"> 参考的加价比率</el-divider>
      <label style="font-weight: bold; margin-right: 6px; font-size: 16px;">分销价加价比率：</label>
      <el-input v-model="selectionGoodsDto.rate" size="small" style="width: 7%; margin-right: 6px;" @blur="editRate(2)"></el-input>
      <label style="font-weight: bold; margin-right: 6px; font-size: 16px;">后台加价比率(/)：</label>
      <el-input v-model="selectionGoodsDto.systemRate" size="small" style="width: 6%; margin-right: 6px;"></el-input>
      <el-divider content-position="left"> 真实使用的加价比率()</el-divider>
      <label style="font-weight: bold; margin-right: 6px; font-size: 16px;">后台加价比率(/)：</label>
      <el-input-number v-model="selectionGoodsDto.disPrice" controls-position="right" placeholder="请输入加价比例" style="width: 20%"></el-input-number>
      <div slot="footer" class="dialog-footer">
        <el-button @click="markUpVisible = false">取 消</el-button>
        <el-button type="primary" @click="addGoodsInSelectionTopicGoodsRelation(selectionGoodsDto.item,selectionGoodsDto.type)">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="挑选商品到多个选品库" :visible.sync="topicVisible" @close="closeTopicVisible()" :append-to-body='true'
               :close-on-click-modal='false'
               :close-on-press-escape='false'>
      <el-select v-model="topicListDto" multiple filterable allow-create placeholder="请选择">
        <el-option
            v-for="item in topicListVo"
            :key="item.id"
            :label="item.title"
            :value="item.id">
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeTopicVisible()">取 消</el-button>
        <el-button type="primary" @click="addGoodsInSelectionTopicGoodsRelation(topicVo,2)">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="新增当前选品库标签" :visible.sync="tagVisible" @close="closeTagVisible()" :append-to-body='true'
               :close-on-click-modal='false'
               :close-on-press-escape='false'>
      <el-form ref="tagForm" :model="tagDo" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="选品库">
              <!--@change="handleTagTopicIdChange"-->
              <el-select v-model="tagDo.topicId" filterable allow-create placeholder="请选择选品库" >
                <el-option
                    v-for="item in topicListVo"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="标签名称">
              <el-input minlength="2" clearable v-model="tagDo.tagName" placeholder="请输入标签名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="一级类别">
              <el-select filterable v-model="tagDo.categoryId1" placeholder="请选择" style="width: 100%"
                         @change="getOtherCategoryNoTopicList(1)">
                <el-option label="请选择" value="">
                </el-option>
                <el-option
                    v-for="(item,index) in categoryId1"
                    :key="index"
                    :label="item.fullName"
                    :value="item.categoryId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="二级类别">
              <el-select filterable v-model="tagDo.categoryId2" placeholder="请选择" style="width: 100%"
                         @change="getOtherCategoryNoTopicList(2)">
                <el-option label="请选择" value="">
                </el-option>
                <el-option
                    v-for="(item,index) in categoryId2"
                    :key="index"
                    :label="item.fullName"
                    :value="item.categoryId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="三级类别">
              <el-select filterable v-model="tagDo.categoryId3" placeholder="请选择" style="width: 100%">
                <el-option label="请选择" value="">
                </el-option>
                <el-option
                    v-for="(item,index) in categoryId3"
                    :key="index"
                    :label="item.fullName"
                    :value="item.categoryId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="商品名称搜索">
              <el-input class="w-260px" minlength="2" clearable v-model="tagDo.skuName" placeholder="请输入要搜索的商品名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="物流信息">
              <el-select filterable v-model="tagDo.logisticsType" placeholder="请选择物流类型" style="width: 100%">
                <el-option label="请选择" value="">
                </el-option>
                <el-option label="京东物流" :value="1">
                </el-option>
                <el-option label="其他物流" :value="2">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="最低评论数">
              <el-input-number class="w-260px" clearable v-model="tagDo.commentOkCount" placeholder="请输入最低评论数"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="最低折扣">
              <el-input-number class="w-260px" clearable v-model="tagDo.minProfitMargi" placeholder="请输入最低折扣"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最高折扣">
              <el-input-number class="w-260px" clearable v-model="tagDo.maxProfitMargi" placeholder="请输入最高折扣"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeTagVisible()">取 消</el-button>
        <el-button type="primary" @click="addTags(2)">确 定</el-button>
      </div>
    </el-dialog>

    <JdAddressListDelivery
        :selected-addresses="selectedAddresses"
        @update:addresses="handleAddressUpdate"
        append-to-body
        ref="jdAddressListDelivery"/>
  </div>
</template>
<script>
import {mixins} from "@/views/SelectGoods/components/Goods/mixins";

export default {
  mixins: [mixins]
}
</script>
<style>
#topicGoodsForm div label.el-form-item__label {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

#topicGoodsForm .el-form-item {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

.el-table .warning-row {
  background: oldlace;
}

.title-ellipsis {
  display: inline-block;
  max-width: 200px; /* 根据实际列宽调整 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

/* 层级缩进 */
.level-1 {
  margin-left: 30px;
  border-left: 2px solid #409eff;
}

/* 字体颜色区分 */
.level-1 .cell {
  color: #666;
}

.level-2 .cell {
  color: #999;
}

/* 加载状态样式 */
.el-table__expand-column .cell {
  padding: 0 !important;
}

/* 添加以下样式 */
.full-title {
  white-space: normal !important; /* 允许换行 */
  word-break: break-word; /* 强制长单词/URL换行 */
  overflow-wrap: anywhere; /* 更智能的换行策略 */
  display: inline-block; /* 确保宽度自适应 */
  max-width: 100%; /* 限制最大宽度 */
}

</style>